// extracted by mini-css-extract-plugin
module.exports = {"infoCard":"InfoCard_infoCard__C8iTV","infoCardSmall":"InfoCard_infoCardSmall__pkTsb"};